/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $LeagueImport_Output = {
    properties: {
        name: {
            type: 'TranslationCreate',
            isRequired: true,
        },
        officialName: {
            type: 'string',
            isRequired: true,
        },
        internalName: {
            type: 'string',
            isRequired: true,
        },
        areasOfInterest: {
            type: 'array',
            contains: {
                type: 'AreaOfInterest',
            },
            isRequired: true,
        },
        sports: {
            type: 'SportEnum',
            isRequired: true,
        },
        tableRating: {
            type: 'LeagueRatingEnum',
            isRequired: true,
        },
        main: {
            type: 'boolean',
            isRequired: true,
        },
        year: {
            type: 'number',
            isRequired: true,
        },
        category: {
            type: 'LeagueCategory',
            isRequired: true,
        },
    },
} as const;
